import ApplicationResource from "./ApplicationResource";
import asPagedContentSchema from "./utils/asPagedContent";
export default class ApplicationPaginatedResource extends ApplicationResource {
    static list() {
        return super.list().extend({
            schema: asPagedContentSchema(this)
        });
    }
    static appendList(newResults, existingResults) {
        var _a;
        // In case there are duplicates, Set will eliminate them.
        const set = new Set([
            ...((_a = existingResults === null || existingResults === void 0 ? void 0 : existingResults.content) !== null && _a !== void 0 ? _a : []),
            ...newResults.content,
        ]);
        return Object.assign(Object.assign({}, newResults), { content: [...set.values()] });
    }
    /**
     * @deprecated This method was replaced by list and will be removed in another release
     */
    static listShape() {
        const readShape = super.listShape();
        return Object.assign(Object.assign({}, readShape), { schema: asPagedContentSchema(this), options: Object.assign(Object.assign({}, readShape.options), { invalidIfStale: true }) });
    }
}
//# sourceMappingURL=ApplicationPaginatedResource.js.map